import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "./pages/MainPage";
import EventPage from "./pages/EventPage";
import SeatingPage from "./pages/SeatingPage";
import { AuthProvider } from './contexts/AuthContext';
import SignupPage from './pages/SignupPage';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import CheckoutPage from './pages/CheckoutPage';
import Footer from './components/Footer';
import { eventService } from './services/api.service';
import SearchResults from './pages/SearchResults';
import PaymentConfirmationPage from './pages/PaymentConfirmationPage';
import ProtectedRoute from './components/ProtectedRoute';
import ProfilePage from './pages/profile/ProfilePage';
import UserTickets from './pages/profile/UserTickets';
import UserSettings from './pages/profile/UserSettings';

const App = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                await eventService.getAllEvents();
            } catch (error) {
                console.error('Error fetching events:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchEvents();
    }, []);

    if (loading) return <div>Loading...</div>;

    return (
        <AuthProvider>
            <Router>
                <div className="flex flex-col min-h-screen">
                    <Navbar />
                    <main className="flex-grow">
                        <Routes>
                            <Route path="/" element={<MainPage />} />
                            <Route path="/event/:id" element={<EventPage />} />
                            <Route path="/payment/:id" element={<SeatingPage />} />
                            <Route path="/payment/checkout/:id" element={<CheckoutPage />} />
                            <Route path="/signup" element={<SignupPage />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/checkout" element={<CheckoutPage />} />
                            <Route path="/search" element={<SearchResults />} />
                            <Route path="/seating/:eventId/:subEventId" element={<SeatingPage />} />
                            <Route path="/payment-confirmation" element={<PaymentConfirmationPage />} />
                            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                            <Route path="/profile/tickets" element={<ProtectedRoute><UserTickets /></ProtectedRoute>} />
                            <Route path="/profile/settings" element={<ProtectedRoute><UserSettings /></ProtectedRoute>} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </Router>
        </AuthProvider>
    );
};

export default App;
